import { createContext } from 'react';

// True for the list row the user just added with "Add Item", so the row's
// widget can take focus (and a dropdown can open) when it mounts. Provided
// around every row, not just the new one, so a later Add only flips the value
// and never remounts the earlier row.
export const NewListItemContext = createContext(false);
